import React, { useState } from "react";
import "./OnboardingProfileConfirm.modules.css";
import NavbarOnboarding from "../NavbarOnboarding/NavbarOnboarding";
import { useTranslation } from "react-i18next";
import * as AppUrls from "../../../constants/AppUrls";
import { Redirect } from "react-router-dom";
import KYCimg from "../../../assets/images/Sharjah/KYC.png";

const OnboardingProfileConfirm = () => {
  const { t } = useTranslation();

  const [redirect, setRedirect] = useState(null);

  const [isEditing, setIsEditing] = useState(false);
  const [profile, setProfile] = useState({
    Passport: "xx expiry : xxx ",
    FacialVerification: "test",
    // Signature: 'Jahdahd',
    Address: "Nahda , Dubai",
    FATCA: "Done",
    CRS: "Done",
  });

  const handleEditClick = () => setIsEditing(!isEditing);
  const handleConfirmClick = () => setRedirect(AppUrls.OnboardingNonSIBAccount); //setRedirect(AppUrls.onboardingMain);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile({ ...profile, [name]: value });
  };

  const handleSaveClick = () => setIsEditing(false);
  const handleBack = (e) => {
    e.preventDefault();
    setRedirect(AppUrls.onboardingPersonal);
  };
  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }
  return (
    <>
      <NavbarOnboarding />
      <div className="login-main-container">
        <div className="KYCDivImg">
          <h2 className="OpenYourAccountwithUs">{t("OpenYourAccountwithUs")}</h2>
          <img className="KYCImg" src={KYCimg} />
        </div>
        <div className="UserConfirms-container">
          <div className="UserConfirms-form">
            <div className="profile-card-Onboarding">
              {isEditing ? (
                <div className="profile-edit">
                  <label>{t("Passport")}:</label>
                  <input type="text" name="Passport" value={profile.Passport} onChange={handleChange} />

                  <label>{t("FacialVerification")} :</label>
                  <input type="text" name="FacialVerification" value={profile.FacialVerification} onChange={handleChange} />

                  {/* <label>
                                        {t('Signature')}  :
                                    </label>
                                    <textarea
                                        name="Signature"
                                        value={profile.Signature}
                                        onChange={handleChange}
                                    /> */}

                  <label>{t("address")} :</label>
                  <textarea name="Address" value={profile.Address} onChange={handleChange} />

                  <label>{t("FATCA")} :</label>
                  <textarea name="FATCA" value={profile.FATCA} onChange={handleChange} />

                  <label>{t("CRS")} :</label>
                  <textarea name="CRS" value={profile.CRS} onChange={handleChange} />

                  <button onClick={handleSaveClick}>{t("save")}</button>
                </div>
              ) : (
                <div className="profile-view">
                  <h2 style={{ textAlign: "center" }}> {t("profile")}</h2>
                  <div className="order-horizontal-separator mt-1 mb-2" style={{ float: "left" }} />

                  <label>{t("Passport")}:</label>
                  <p>{profile.Passport}</p>
                  <div className="order-horizontal-separator mt-1 mb-2" style={{ float: "left" }} />

                  <label>{t("FacialVerification")} :</label>
                  <p>{profile.FacialVerification}</p>
                  <div className="order-horizontal-separator mt-1 mb-2" style={{ float: "left" }} />

                  {/* <label>
                                        {t('Signature')}  :
                                    </label>
                                    <p>{profile.Signature}</p>
                                    <div className="order-horizontal-separator mt-1 mb-2" style={{ float: "left" }} /> */}

                  <label>{t("address")} :</label>
                  <p>{profile.Address}</p>
                  <div className="order-horizontal-separator mt-1 mb-2" style={{ float: "left" }} />

                  <label>{t("FATCA")} :</label>
                  <p>{profile.FATCA}</p>
                  <div className="order-horizontal-separator mt-1 mb-2" style={{ float: "left" }} />

                  <label>{t("CRS")} :</label>
                  <p>{profile.CRS}</p>
                  <div className="order-horizontal-separator mt-1 mb-2" style={{ float: "left" }} />

                  <div className="form-group-uploadON" style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                    <button onClick={handleEditClick}>{t("edit")}</button>
                    <button onClick={handleConfirmClick}>{t("Confirm")}</button>
                  </div>
                </div>
              )}
            </div>
            <div>
              {/* <button
                                className={"link"}
                                style={{
                                    width: "100%",
                                    textDecoration: 'underline',
                                    marginTop: "1rem",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    background: "transparent",
                                    border: "none",
                                    color: "#0b1d81",
                                    cursor: "pointer",

                                }}
                                onClick={handleBack}
                            >
                                {t("back")}
                            </button> */}
              {/* <button className="backBtn" onClick={handleBack}>
                {t("back")}
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OnboardingProfileConfirm;
